import React, { useState } from "react";
import * as actions from "../store/actions";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { connect } from "react-redux";
import * as Yup from "yup";

import Spinner from "../assets/spinner/spin-balls.svg";
import Modal from "../components/UI/Modal";
import LogoWhite from "../assets/images/logo-white.png";

import "./OrderForm.scss";

const FormSchema = Yup.object().shape({
    firstName: Yup.string().required("This field is required."),
    lastName: Yup.string().required("This field is required."),
    phone: Yup.string().required("This field is required."),
    email: Yup.string()
        .email("Needs to be valid email.")
        .required("This field is required."),
    address: Yup.string().required("This field is required."),
    city: Yup.string().required("This field is required."),
    extraNote: Yup.string()
});

const OrderForm = ({ cart, cartTotal, placeOrder, error, loading, history }) => {
    const [isOpened, setIsOpened] = useState(false);

    const showCartSummary = cart => {
        return cart.map(item => {
            return (
                <div className="orderForm__inner__cart__inner-order" key={item.id}>
                    <img
                        className="orderForm__inner__cart__inner-order--img"
                        src={item.image.fields.file.url}
                        alt={item.image.description}
                    />
                    <p className="orderForm__inner__cart__inner-order--name">
                        {item.name}{" "}
                        <span className="orderForm__inner__cart__inner-order--name-amount">
                            x{item.amount}
                        </span>
                    </p>
                    <p className="orderForm__inner__cart__inner-order--price">
                        {item.price * item.amount} czk
                    </p>
                </div>
            );
        });
    };

    return (
        <section className="orderForm">
            <div className="container orderForm__inner">
                <div className="orderForm__inner__cart">
                    <h3 className="container orderForm__inner-header">Order summary:</h3>
                    <div className="orderForm__inner__cart__inner">
                        {showCartSummary(cart)}
                        <div>
                            <h5 className="orderForm__inner__cart__inner-header">
                                Total:{" "}
                                <span className="orderForm__inner__cart__inner-header--total">
                                    {cartTotal} czk
                                </span>
                            </h5>
                        </div>
                    </div>
                </div>
                <div className="orderForm__inner-wrapper">
                    <Formik
                        initialValues={{
                            firstName: "",
                            lastName: "",
                            phone: "",
                            email: "",
                            address: "",
                            city: "",
                            extraNote: ""
                        }}
                        validationSchema={FormSchema}
                        onSubmit={async (values, actions) => {
                            const res = await placeOrder(cart, values);
                            actions.setSubmitting(false);
                            if (res) {
                                setIsOpened(true);
                            }
                            actions.resetForm();
                        }}
                        render={({ isSubmitting, isValid, errors, touched }) => (
                            <Form className="orderForm__form">
                                <div className="orderForm__form-fieldWrapper">
                                    <Field
                                        className="orderForm__form-fieldWrapper--field"
                                        type="text"
                                        name="firstName"
                                        placeholder="First name..."
                                    />
                                    <ErrorMessage name="firstName">
                                        {msg => (
                                            <div className="orderForm__form-fieldWrapper--field--error">
                                                {msg}
                                            </div>
                                        )}
                                    </ErrorMessage>
                                </div>

                                <div className="orderForm__form-fieldWrapper">
                                    <Field
                                        className="orderForm__form-fieldWrapper--field"
                                        type="text"
                                        name="lastName"
                                        placeholder="Last name..."
                                    />
                                    <ErrorMessage name="lastName">
                                        {msg => (
                                            <div className="orderForm__form-fieldWrapper--field--error">
                                                {msg}
                                            </div>
                                        )}
                                    </ErrorMessage>
                                </div>

                                <div className="orderForm__form-fieldWrapper">
                                    <Field
                                        className="orderForm__form-fieldWrapper--field"
                                        type="text"
                                        name="phone"
                                        placeholder="Phone number..."
                                    />
                                    <ErrorMessage name="phone">
                                        {msg => (
                                            <div className="orderForm__form-fieldWrapper--field--error">
                                                {msg}
                                            </div>
                                        )}
                                    </ErrorMessage>
                                </div>
                                <div className="orderForm__form-fieldWrapper">
                                    <Field
                                        className="orderForm__form-fieldWrapper--field"
                                        type="email"
                                        name="email"
                                        placeholder="Email.."
                                    />
                                    <ErrorMessage name="email">
                                        {msg => (
                                            <div className="orderForm__form-fieldWrapper--field--error">
                                                {msg}
                                            </div>
                                        )}
                                    </ErrorMessage>
                                </div>
                                <div className="orderForm__form-fieldWrapper">
                                    <Field
                                        className="orderForm__form-fieldWrapper--field"
                                        type="text"
                                        name="address"
                                        placeholder="Address..."
                                    />
                                    <ErrorMessage name="address">
                                        {msg => (
                                            <div className="orderForm__form-fieldWrapper--field--error">
                                                {msg}
                                            </div>
                                        )}
                                    </ErrorMessage>
                                </div>
                                <div className="orderForm__form-fieldWrapper">
                                    <Field
                                        className="orderForm__form-fieldWrapper--field"
                                        type="text"
                                        name="city"
                                        placeholder="City and PSC..."
                                    />
                                    <ErrorMessage name="city">
                                        {msg => (
                                            <div className="orderForm__form-fieldWrapper--field--error">
                                                {msg}
                                            </div>
                                        )}
                                    </ErrorMessage>
                                </div>
                                <div className="orderForm__form-fieldWrapper">
                                    <Field
                                        className="orderForm__form-fieldWrapper--field"
                                        type="text"
                                        name="extraNote"
                                        placeholder="Extra note for cheef..."
                                    />
                                </div>
                                <button
                                    disabled={!isValid || isSubmitting}
                                    className="btn-primaryc plr-25 orderForm__form-button"
                                    type="submit"
                                    color="red"
                                >
                                    Order
                                </button>
                            </Form>
                        )}
                    />
                </div>
            </div>
            {loading ? (
                <div className="orderForm__spinner">
                    <img src={Spinner} alt="loading..." />
                </div>
            ) : null}
            <Modal
                opened={isOpened}
                close={() => {
                    setIsOpened(false);
                    history.push("/");
                }}
            >
                <div className="orderForm__modal">
                    <h3 className="orderForm__modal-header">
                        Your order has been recived
                    </h3>
                    <p className="orderForm__modal-text">
                        Check your email to see when you should expect us
                    </p>
                    <div className="orderForm__modal-imgWrapper">
                        <img
                            className="orderForm__modal-imgWrapper--img"
                            src={LogoWhite}
                            alt="logo"
                        />
                    </div>
                </div>
            </Modal>
        </section>
    );
};

const mapStateToProps = ({ menu }) => ({
    cart: menu.cart,
    cartTotal: menu.cartTotal,
    error: menu.error,
    loading: menu.loading
});

const mapDispatchToProps = {
    placeOrder: actions.placeOrder
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OrderForm);
